import { CheckIcon, XMarkIcon } from "@heroicons/react/20/solid";

export const CircleStepProgressbar = ({ steps=[] }) => {
  return (
    <ol className="flex items-center">
      {steps.map((step, stepIdx) => (
        <li key={step.name} className="relative">
          {step.status === 'complete' ? (
            <>
              <div aria-hidden="true" className={`absolute inset-0 ${stepIdx === 0 && 'left-1/2'} ${stepIdx === steps.length - 1 && 'right-1/2'} flex items-center`}>
                <div className="h-0.5 w-full bg-perception-gray-700" />
              </div>
              <div className="w-48 flex flex-col items-center relative">
                <span className="relative flex size-8 items-center justify-center rounded-full bg-perception-blue">
                  <CheckIcon aria-hidden="true" className="size-5 text-white" />
                </span>
                <div className="absolute text-center mt-10 text-white max-w-20 md:max-w-full">
                  {step.name}
                </div>
              </div>
            </>
          ) : step.status === 'current' ? (
            <>
              <div aria-hidden="true" className={`absolute inset-0 ${stepIdx === 0 && 'left-1/2'} ${stepIdx === steps.length - 1 && 'right-1/2'} flex items-center`}>
                <div className="h-0.5 w-full bg-perception-gray-700" />
              </div>
              <div className="w-48 flex flex-col items-center relative">
                <style>{`@keyframes bounceScale {0%, 100% {transform: scale(1);} 50% {transform: scale(1.2);}}`}</style>
                <span className="size-8 rounded-full animate-[bounceScale_2s_ease-in-out_infinite] bg-white border border-2 border-perception-blue"/>
                <div className="absolute text-center mt-10 text-perception-gray-500 max-w-20 md:max-w-full">
                  {step.name}
                </div>
              </div>
            </>
          ) : step.status === 'error' ? (
            <>
              <div aria-hidden="true" className={`absolute inset-0 ${stepIdx === 0 && 'left-1/2'} ${stepIdx === steps.length - 1 && 'right-1/2'} flex items-center`}>
                <div className="h-0.5 w-full bg-perception-gray-700" />
              </div>
              <div className="w-48 flex flex-col items-center relative">
                <span className="relative flex size-8 items-center justify-center rounded-full bg-error">
                  <XMarkIcon aria-hidden="true" className="size-5 text-white" />
                </span>
                <div className="absolute text-center mt-10 text-error max-w-20 md:max-w-full">
                  {step.name}
                </div>
              </div>
            </>
          ) : (
            <>
              <div aria-hidden="true" className={`absolute inset-0 ${stepIdx === 0 && 'left-1/2'} ${stepIdx === steps.length - 1 && 'right-1/2'} flex items-center`}>
                <div className="h-0.5 w-full bg-perception-gray-700" />
              </div>
              <div className="w-48 flex flex-col items-center relative">
                <span className="relative flex size-8 items-center justify-center rounded-full bg-perception-gray-700 border border-2 border-perception-gray-600">
                </span>
                <div className="absolute text-center mt-10 text-perception-gray-600 max-w-20 md:max-w-full">
                  {step.name}
                </div>
              </div>
            </>
          )}
        </li>
      ))}
    </ol>
  )
}